export enum AnimatedGifsVariants {
  SingleImage = 'singleImage',
  DoubleImage = 'doubleImage',
  TripleImage = 'tripleImage',
  ImageWithText = 'imageWithText',
}
